export const getLeaveStatusInfo = (status) => {
  switch (status) {
    case "approved":
      return {
        text: "Approved",
        color: "success",
        icon: "check_circle",
      };
    case "pending":
      return {
        text: "Pending",
        color: "info",
        icon: "hourglass_empty",
      };
    case "rejected":
      return {
        text: "Rejected",
        color: "error",
        icon: "cancel",
      };
    case "cancelled":
      return {
        text: "Cancelled",
        color: "error",
        icon: "block",
      };
    default:
      return {
        text: status,
        color: "secondary",
        icon: "help",
      };
  }
};
